// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"onobarding-input-modal_wrapper__BsYBD"};